module.exports = __webpack_public_path__ + "img/chair.e6f124da.jpg";